module.exports = __webpack_public_path__ + "assets/img/24_qr_download_9tipp.644b54ea.png";